import { Address } from "./address.model";
import { Roles, Status } from "./user.model";

export class Organization {
  constructor(
    public address: Address = new Address(),
    public cnpj: string = "",
    public id?: string,
    public isCompany: boolean = true,
    public name: string = "",
    public status: Status = Status.ACTIVATED,
    public contacts: Contact[] = [new Contact()],
  ) {}
}

export class Contact {
  constructor(
    public name: string = "",
    public department: string = "",
    public email: string = "",
    public phone: string = "",
    public type: string = Roles.ADMINISTRATOR,
  ) {}
}
